module.exports = __webpack_public_path__ + "static/media/Logo.f6868982.svg";